import { immediateToast } from "izitoast-react";

export default function deleteConfirmationPrompt(
  executeThisFunctionWithConsent,
  funcProps
) {
  new Promise((resolve) => {
    immediateToast("question", {
      timeout: 20000,
      close: false,
      overlay: true,
      displayMode: "once",
      id: "question",
      zindex: 9999,
      title: "Delete Request",
      message: "Are you sure about that?",
      position: "center",
      buttons: [
        [
          `<button><b>YES</b></button>`,
          function (instance, toast) {
            instance.hide({ transitionOut: "fadeOut" }, toast, "button");

            resolve("yes");
          },
          true,
        ],
        [
          `<button>NO</button>`,
          function (instance, toast) {
            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
          },
        ],
      ],
    });
  })
    .then((responce) => {
      if (funcProps) {
        executeThisFunctionWithConsent(...funcProps);
      } else {
        executeThisFunctionWithConsent();
      }
    })
    .catch((err) => console.log("error:", err));
}
